﻿/**
 * Encode String to HTML encoded String.
 *
 * Use TextNode to let browser do encoding.
 * Copied from: https://docs.veracode.com
 * @param {string} value String to encode
 * @returns {string} Encoded string
 */
export function vcEncodeHtml(value: string): string {
    const text = document.createTextNode(value);
    const p = document.createElement("p");
    p.appendChild(text);
    return p.innerHTML;
}
